module.exports = __webpack_public_path__ + "img/logo.e8ad1f90.png";